import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SiteNavActions from "../SiteNavActions/SiteNavActions";
import useSectionNavigation from "../../hooks/useSectionNavigation";
import { useTheme, THEME_TOGGLE_ENABLED } from "../../context/ThemeContext";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const goToSection = useSectionNavigation();
  const { theme, toggleTheme } = useTheme();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`${styles.siteHeader} ${scrolled ? styles.siteHeaderScrolled : ""}`}>
      <div className={styles.navTop}>
        <div className={`container ${styles.navTopInner}`}>
          <button type="button" className={styles.logo} onClick={() => navigate("/")}>
            <img className={styles.logoImg} src="/timeline-logo.jpeg" alt="Timeline logo" />
            <span className={styles.logoText}>Timeline</span>
          </button>

          <div className={styles.links}>
            <SiteNavActions
              onNav={goToSection}
              btnClassName={styles.navBtn}
              downloadRowClassName={styles.downloadRow}
              webLinkClassName={styles.webCta}
            />
            <button
              type="button"
              className={`${styles.themeToggle} ${!THEME_TOGGLE_ENABLED ? styles.themeToggleHidden : ""}`}
              onClick={toggleTheme}
              aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
              title={theme === "dark" ? "Light mode" : "Dark mode"}
              aria-hidden={!THEME_TOGGLE_ENABLED}
              tabIndex={THEME_TOGGLE_ENABLED ? 0 : -1}
            >
              {theme === "dark" ? "☀" : "☾"}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
